import API from '@/api/path'
import { baseFetch } from '@/api/axiosBase'

const numberPlateModule = {
  state: {
    vehicleList: [],
    entryRecordList: [],
    htDevices: []
  },
  actions: {
    // 取得車辨設備列表
    async getHtDevice({ commit, rootState }) {
      const communityId = rootState.commonModule.currentCommunityId
      const res = await baseFetch(
        API.getDeviceList.url,
        API.getDeviceList.method,
        {
          commulityId: communityId,
          profiles: 'vehicleGate'
        }
      )
      if (!res.isError && res.data) {
        commit('SET_HT_DEVICES', res.data.data)
      }
    },
    // 根據社區編號，設備序號(code)取得車輛列表，停車場ID(code)
    async fetchVehicleList({ commit, rootState }, params) {
      const currentCommunityId = rootState.commonModule.currentCommunityId
      try {
        const res = await baseFetch(
          API.getVehicleList.url,
          API.getVehicleList.method, 
          {
            communityId : currentCommunityId,
            ...params
          }
        )
        if (!res.isError && res.data) {
          // console.log('vehicleData:'+JSON.stringify(res.data))
          commit('SET_VEHICLE_LIST', res.data.data)
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    // 新增車輛
    addVehicle(_, bodyData) {
      // 回到頁面處理
      return baseFetch(
        API.addVehicle.url,
        API.addVehicle.method, 
        bodyData
      )
    },
    // 根據車輛編號刪除車輛
    deleteVehicle(_, { vehicleId }) {
      // 回到頁面處理
      return baseFetch(
        API.deleteVehicle.url(vehicleId),
        API.deleteVehicle.method
      )
    },
    // 根據車輛編號取得車輛資訊
    getVehicleInfo(_, { vehicleId }) {
      // 回到頁面處理
      return baseFetch(
        API.getVehicleInfo.url(vehicleId),
        API.getVehicleInfo.method
      )
    },
    // 根據車輛編號修改車輛資訊
    updateVehicleInfo(_, { vehicleId, ...bodyData }) {
      // 回到頁面處理
      return baseFetch(
        API.updateVehicleInfo.url(vehicleId),
        API.updateVehicleInfo.method,
        bodyData
      )
    },
    // 車輛名單管理匯入
    importVehicleList({ rootState }, payload) {
      // console.log(payload)
      const currentCommunityId = rootState.commonModule.currentCommunityId

      const { file } = payload
      let formData = new FormData()
  		formData.append('file', file)

      // 回到頁面處理
      return baseFetch(
        API.importVehicleList.url(currentCommunityId),
        API.importVehicleList.method,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      )
    },
    // 取得車輛進出紀錄
    async getEntryRecord({ commit, rootState }, bodyData ){
      const currentCommunityId = rootState.commonModule.currentCommunityId

      const res = await baseFetch(
        API.entryRecord.url,
        API.entryRecord.method, 
        {
          communityId : currentCommunityId,
          ...bodyData
        }
      )
      if (!res.isError && res.data) {
        // console.log('getEntryRecord:'+JSON.stringify(res.data))
        commit('SET_ENTRY_RECORD_LIST', res.data.data)
      }
    }
  },
  mutations: {
    SET_VEHICLE_LIST(state, payload) {
      state.vehicleList = payload
    },
    SET_ENTRY_RECORD_LIST(state, payload) {
      state.entryRecordList = payload
    },
    SET_HT_DEVICES(state, payload) {
      state.htDevices = payload
    },
  },
  getters: {
    getVehicleList: (state) => state.vehicleList,
    getEntryRecordList: (state) => state.entryRecordList,
    getHtDevices: (state) => state.htDevices,
  },
  namespaced: true
}

export default numberPlateModule